import axios from "axios";
import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { useHistory } from "react-router-dom";
import message from "../../../../../../../../src/assets/images/Souvenir/email 1.png";
import "./CricketJerseryAdmin.css";
const AuctionDoneModal = (props) => {
  const history = useHistory();



  const [bidderInfo, setBidderInfo] = useState();

  useEffect(() => {
    axios
      .get(`/api/admin/bidderInfo/auction/${props.checkoutId}`)
      .then((res) => {
        if (res.status === 200) {
          setBidderInfo(res.data.bidderInfo);
        }
      });
  }, [props.checkoutId]);

  const makeWinner = () => {
    axios.post(`/api/admin/winner/auction/${props.checkoutId}`).then((res) => {
      if (res.status === 200) {
        history.push(`/superstar-admin/auction/product-list/sold`);
      }
    });
  };

  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Body className="bg-dark" style={{ border: "2px solid yellow" }}>
        <div className="container">
          <div className="text-center p-3">
            <img src={message} alt="" className="img-fluid" />
            <h3 className="text-light">Confirm placement</h3>
            <p className="text-light">
              <span className="text-warning fw-bold">{bidderInfo?.name}</span>{" "}
              Lorem ipsum dolor sit amet, consectetur adipisicing elit. Natus
              voluptatibus temporibus dolorum non. Veniam{" "}
              <span className="text-warning fw-bold">
                ${bidderInfo?.amount}
              </span>{" "}
              enim inventore recusandae nihil dignissimos suscipit maiores? Sit
              est fugiat obcaecati porro accusamus deleniti perferendis id?{" "}
              <span className="text-warning fw-bold">success</span>{" "}
            </p>

            <button className="btn btn-outline-warning" onClick={props.onHide}>
              Go back
            </button>
            <button className="btn btn-warning mx-3" onClick={makeWinner}>
              Auction done!
            </button>
          </div>
        </div>
      </Modal.Body>
      {/* <Modal.Footer className="d-flex justify-content-center align-items-center bg-dark">
        <Button onClick={props.onHide}>Close</Button>
      </Modal.Footer> */}
    </Modal>
  );
};

export default AuctionDoneModal;
